module.exports = __webpack_public_path__ + "img/lair.6455ca21.webp";